import { render, staticRenderFns } from "./TimeCaseDetail.vue?vue&type=template&id=371dda7f&scoped=true&"
import script from "./TimeCaseDetail.vue?vue&type=script&lang=js&"
export * from "./TimeCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./TimeCaseDetail.vue?vue&type=style&index=0&id=371dda7f&lang=less&scoped=true&"
import style1 from "./TimeCaseDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371dda7f",
  null
  
)

export default component.exports